import { render, staticRenderFns } from "./GridComponent.vue?vue&type=template&id=104dd20c&scoped=true&"
import script from "./GridComponent.vue?vue&type=script&lang=ts&"
export * from "./GridComponent.vue?vue&type=script&lang=ts&"
import style0 from "./GridComponent.vue?vue&type=style&index=0&id=104dd20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104dd20c",
  null
  
)

export default component.exports